import { useEffect, useState } from "react";
import { MdOutlineLockClock } from "react-icons/md";
import './CountdownTimer.css';

export function CountdownTimer({ date, onEnd, ...props }) {
	const [time, setTime] = useState(date);

	function updateTime(time) {
		const hours = Math.floor(time / (60 * 60 * 1000));
		const minutes = Math.floor((time % (60 * 60 * 1000)) / (1000 * 60));
		const seconds = Math.floor((time - (hours * 60 * 60 * 1000) - (minutes * 60 * 1000)) / 1000);
		setTime(`${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
		if (time === 0) {
			onEnd?.();
		}
	}

	useEffect(() => {
		let currentTime = Math.abs(new Date(date).getTime() - new Date().getTime());
		updateTime(currentTime);
		const interval = setInterval(() => {
			currentTime = Math.max(currentTime - 1000, 0);
			updateTime(currentTime);
		}, 1000);
		return () => clearInterval(interval);
	}, [date])

	return (
		<span className="countdown-timer">
			<MdOutlineLockClock size={14} />
			<span>{time}</span>
		</span>
	)
}